import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ChangeDetectorRef,
  Output,
  signal,
  HostListener,
  SimpleChanges,
  OnChanges,
  // PLATFORM_ID
} from '@angular/core';
// import { isPlatformBrowser } from '@angular/common';
import { Heatmap } from 'heatmap-component';
import * as d3 from 'd3';
// import { formatDataItem } from 'heatmap-component/lib/heatmap-component/utils';

import { Subject, catchError, debounceTime, from, map, switchMap } from 'rxjs';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { AM_COLOR_SCALE } from '../molstar-alpha-missense';
import { PlatformService } from '../platform.service';
import { PAUL_TOL_COLORBLIND_SCALE } from './annotations-constant';
import { scaleThreshold } from 'd3';
interface ColorScheme {
  scheme: string;
  trackData: {
      trackId: number;
      trackName: string;
      start: number;
      end: number;
      color: string;
  };
}
@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.css'],
  standalone: false,
})

export class HeatmapComponent implements OnInit, OnChanges {
  @Input() accession: string;
  @Input() csvAmData: any;
  @Input() heatmapSequence: string;
  @Input() amAnnotationsHg19Url: string;
  @Input() amAnnotationsHg38Url: string;
  @Input() csvAMFileUrl: string;
  @Input() plddtData: any;
  @Input() colorScheme: string;

  @Output() selectedRegion: EventEmitter<Object> = new EventEmitter();
  @Output() clearRegion: EventEmitter<Object> = new EventEmitter();
  @Output() selectedCategory: EventEmitter<Object> = new EventEmitter();
  @Output() onChangeColor: EventEmitter<Object> = new EventEmitter();
  @Output() onProtvistaMouseEvent: EventEmitter<Object> = new EventEmitter();

  yourdata: any;

  length: number;
  variantsData: any;
  canvasEl: any;

  isPathogenic: boolean = false;
  isBenign: boolean = false;
  isUncertain: boolean = false;
  isAll: boolean = true;
  isReset: boolean = false;

  isPathogenicDisabled: boolean = true;
  isBenignDisabled: boolean = true;
  isUncertainDisabled: boolean = true;
  selectedCategories: string[] = []; // Array to store selected values
  selectedRange: any = '';

  heatmapOne: Heatmap<
    number,
    string,
    { score: number; start: number; variant: string; category: string }
  >;

  data: number[][];

  filterBy: Array<string>;

  previousZoom: [number, number] = [-10, -10]; // Added for Nightingale zooming
  private zoomSubject = new Subject<{ id: string; zoom: [number, number] }>();
  private zoomSubject2 = new Subject<{ id: string; zoom: [number, number] }>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public gaService: GoogleAnalyticsService,
    private platform: PlatformService
  ) {}

  width: number;
  filterRangeMin: number = 0; // Set initial filter range to 1
  filterRangeMax: number = 1;

  silder1Min: number = 0;
  silder1Max: number = 0.34;

  silder2Min: number = 0.34;
  silder2Max: number = 0.56;

  silder3Min: number = 0.56;
  silder3Max: number = 1;

  isBrowser: boolean = false;
  public showZoomHint = signal(true);

  public customTracks = [];
  public customRawData = [];
  private customTrackCounter = 0;
  public currentTrack = {};
  public selectedTrack = {};
  public isAddDialogOpen = false;
  public isEditDialogOpen = false;
  public isZoomDialogOpen = false;

  public afdbEntityId = '1';
  public afdbChainId = 'A';
  public afdbTooltips = {};
  public afdbData = signal<any[]>([{}]);

  private renderedPLDDT = false;
  private renderedAFMissense = false;

  private checkedPLDDT = false;
  private checkedAFMissense = false;
  public visReadyToRender = false;

  // TODO: Fixed tooltip position to last of track and adjust when zoomed in/out
  async ngOnInit(): Promise<void> {
    this.isBrowser = this.platform.isBrowserPlatform();

    if (this.isBrowser) {
      await import('@nightingale-elements/nightingale-manager');
      await import('@nightingale-elements/nightingale-navigation');
      await import('@nightingale-elements/nightingale-sequence');
      await import('@nightingale-elements/nightingale-sequence-heatmap');
      await import('@nightingale-elements/nightingale-colored-sequence');
      await import('@nightingale-elements/nightingale-track-canvas');
    }

    // subject below calls nightingale zoom events with debouncing if needed
    this.hideSequenceAxis();
    this.fixRectSize();
    this.changeDetectorRef.detectChanges();
    if (this.isBrowser) {
      await this.initHeatMap();
    }
  }

  private async updateAlphaMissenseData() {
    const variants = await this.fetchAndProcessVariants();
    if (variants) {
      const maxValue = parseFloat(d3.max(variants, (d: any) => d.start + 1)!);
      const xDomain = d3.range(1, maxValue);

      this.afdbData.update((tracks) => {
        // create a shallow copy of the array and modify its first element
        const newTracks = [...tracks];
        newTracks.push({
          id: 'alpha-missense',
          type: 'TrackHeatmapSequence',
          name: 'AlphaMissense Pathogenicity Heatmap',
          heatmapId: 'heatmap-test',
          data: variants,
          xDomain,
          yDomain: ['G','A','V','L','I','S','T','C','M','D','N','E','Q','R','K','H','F','Y','W','P'],
          checkpoints: [0, 0.1132, 0.2264, 0.3395, 0.4527, 0.5895, 0.7264, 0.8632, 1],
          colours: ['#2166ac', '#4290bf', '#8cbcd4', '#c3d6e0', '#e2e2e2', '#edcdba', '#e99e7c', '#d15e4b', '#b2182b'],
          status: 'ready-has-data',
          isExpandable: false,
          trackHeight: 295,
          colourIn3DControl: true,
          hasXScale: true,
          xScaleText: 'Residue sequence number',
          hasYScale: true,
          yScaleText: 'Alternative amino acids',
          mirrorYScale: true,
          tooltipContentFn: (d: any, x: number, y: number) => {
            if (!d) return '';
            let tooltipContent = `
              <div class="tooltip-data" data-trackid="alpha-missense" style="display: none"></div>
              Score: <b>${d.score.toFixed(3)}</b><br>
              Variant: <b>${d.referenceVariant}${x}${y}</b><br>
            `;
            if (d.category === 'wt') {
              tooltipContent = `
                <div class="tooltip-data" data-trackid="alpha-missense" style="display: none"></div>
                Score: <b>N/A</b><br>
                Variant: <b>${d.referenceVariant}${x} (reference)</b><br>
              `;
            }
            return tooltipContent;
          },
        });
        return newTracks;
      });
    }

    this.checkedAFMissense = true;
  }

  private async updatePLDDTData() {

    const plddtForHeatmap: any[] = [];
    for (let i = 0; i < this.plddtData.residueNumber.length; i++) {
      const resNum = this.plddtData.residueNumber[i];
      const scoreVal = this.plddtData.confidenceScore[i];
      plddtForHeatmap.push({
        resid: this.heatmapSequence[resNum-1],
        score: scoreVal,
        start: resNum,
        xValue: resNum,
        yValue: "Score"
      });
    }

    const xDomain = d3.range(1, plddtForHeatmap.length+1);

    this.afdbData.update((tracks) => {
      // create a shallow copy of the array and modify its first element
      const newTracks = [...tracks];
      newTracks[0] = {
        id: 'plddtHeatmap',
        type: 'TrackHeatmapSequence',
        name: 'pLDDT',
        heatmapId: 'heatmap-plddt',
        data: plddtForHeatmap,
        xDomain,
        yDomain: ['Score'],
        checkpoints: [0, 50, 70, 90, 100],
        colours: ['#ff7d45', '#ffdb13', '#65cbf3', '#0053d6', '#0053d6'],
        status: 'ready-has-data',
        isExpandable: false,
        trackHeight: 20,
        colourIn3DControl: true,
        hasXScale: false,
        hasYScale: false,
        tooltipContentFn: (d: any, x: number, y: number) => {
          if (!d) return '';
          let tooltipContent = `
            <div class="tooltip-data" data-trackid="plddtHeatmap" style="display: none"></div>
            Residue: <b>${d.resid}${x}</b><br>
            pLDDT: <b>${d.score.toFixed(2)}</b><br>
          `;
          return tooltipContent;
        },
        customColourScale: scaleThreshold<number, string>()
          .domain([50, 70, 90]) // thresholds (N = 3)
          .range(['#ff7d45', '#ffdb13', '#65cbf3', '#0053d6']) // N + 1 = 4 colors
      };
      return newTracks;
    });

    this.checkedPLDDT = true;
  }

  async ngOnChanges(_changes: SimpleChanges) {
    const convertPLDDTtoTrack = this.renderedPLDDT === false && this.visReadyToRender === false;
    const convertAFMISSENSEtoTrack = this.renderedAFMissense === false && this.visReadyToRender === false;
    if (this.plddtData !== undefined && convertPLDDTtoTrack) {
      await this.updatePLDDTData();
    }
    if (this.csvAmData !== undefined && convertAFMISSENSEtoTrack) {
      await this.updateAlphaMissenseData(); // trigger async load once
    }
    if (this.checkedPLDDT && this.checkedAFMissense && this.visReadyToRender === false) {
      this.visReadyToRender = true;
    }
  }
  
  public editAnnotationsTrack(event){
    const updatedCustomTracks = event.customTracks;
    this.customTracks = updatedCustomTracks;
   
    const eventObj = new CustomEvent('PDBe.NewProtvista.SetCustomData', {
      detail: {
        data: this.customTracks
      },
      bubbles: true,
      cancelable: true,
    });

    document.dispatchEvent(eventObj);
    this.isEditDialogOpen = false;

    this.gaService.eventEmitter('add_custom_track', 'custom_annotations', 'click', 'track_added', `User edited custom annotation track, total tracks:${this.customTracks.length}`);
  }
  
  mapYourData(rawData) {
    this.customRawData.push(rawData);
    const trackName = rawData.trackName.length >= 15 ? rawData.trackName.slice(0,15) + "..." : rawData.trackName;
    const trackId = this.customTrackCounter++;
    const trackColor = PAUL_TOL_COLORBLIND_SCALE[trackId%PAUL_TOL_COLORBLIND_SCALE.length];

    // TODO for datum of rawData
    const segments: string[] = rawData.residueRanges.split(',');
    const fragments = segments.map((segmentString: string) => {
      let start = segmentString.trim();
      let end = segmentString.trim();
      if (segmentString.includes('-')) {
        start = start.split('-')[0];
        end = end.split('-')[1];
      }
      const tooltipContent = `
        Track name: <b>${rawData.trackName}</b><br>
        Residues: <b>${segmentString}</b>
      `;
      return {
        start: parseInt(start),
        end: parseInt(end),
        tooltipContent
      }
    });

    const trackData = {
      id: `custom-${trackId}`,
      type: 'TrackCanvas',
      name: trackName,
      status: 'ready-has-data',
      isSticky: false,
      isCustomData: true,
      isExpandable: false,
      colourIn3DControl: true,
      positionIndex: 1,
      rawData,
      data: [{
        accession: `custom-track-${trackId}`,
        label: rawData.trackName,
        color: trackColor,
        locations: [{
          fragments
        }]
      }]
    }
    this.customTracks.push(trackData);
    
    const eventObj = new CustomEvent('PDBe.NewProtvista.SetCustomData', {
      detail: {
        data: this.customTracks
      },
      bubbles: true,
      cancelable: true,
    });

    document.dispatchEvent(eventObj);
    this.isAddDialogOpen = false;
    this.gaService.eventEmitter('add_custom_track', 'custom_annotations', 'click', 'track_added', `User added custom annotation track, details:trackName:${rawData.trackName} `);
  }

  updateStructureColor(event){
    if(event.scheme === "custom"){
      this.selectedTrack = event.trackData
    }
    this.onChangeColor.emit(event);
  }
  
  @HostListener('document:protvista-mouseover', ['$event'])
  handleNewPvMouseoverEvent(event: Event) {
    const customEvent = event as CustomEvent<any>;
    const detail = customEvent.detail;
    if (!detail) return;
    this.onProtvistaMouseEvent.emit({
      eventType: 'mouseover',
      detail: {start: detail.start, end: detail.end}
    });
  }

  @HostListener('document:protvista-mouseout', ['$event'])
  handleNewPvMouseoutEvent(_event: Event) {
    this.onProtvistaMouseEvent.emit({
      eventType: 'mouseout',
      detail: {start: undefined, end: undefined}
    });
  }

  @HostListener('document:protvista-click', ['$event'])
  handleNewPvClickEvent(event: Event) {
    const customEvent = event as CustomEvent<any>;
    const detail = customEvent.detail;
    if (!detail) return;
    this.onProtvistaMouseEvent.emit({
      eventType: 'click',
      detail: {start: detail.start, end: detail.end}
    });
  }

  @HostListener('document:protvista-close-pin', ['$event'])
  handleNewPvUnselectEvent(_event: Event) {
    this.onProtvistaMouseEvent.emit({
      eventType: 'unselect',
      detail: {start: undefined, end: undefined}
    });
  }

  @HostListener('document:change', ['$event'])
  onNightingaleChangeEvent(event: Event) {
    // 3 - Sanity check for detail data inside this custom event
    const customEvent = event as CustomEvent<any>;
    const detail = customEvent.detail;
    if (!detail) return;

    // 5 - If event is Nightingale zoom event (has display-start display-end inside event.detail)
    if (detail['display-start'] && detail['display-end']) {
      this.gaService.eventEmitter(
        'AM_heatmap_zoom',
        'AlphaMissense',
        'zoom',
        'heatmap_zoom',
        'Zooming into sequence on heatmat'
      );
      return;
    }
  }

  // Helper taken from: https://stackoverflow.com/questions/5525071/how-to-wait-until-an-element-exists
  async awaitElementIsRendered(querySelectorTxt) {
    return await new Promise((resolve) => {
      const platformdocument = this.platform.getDocument();
      if (platformdocument.querySelector(querySelectorTxt)) {
        return resolve(platformdocument.querySelector(querySelectorTxt));
      }

      const observer = new MutationObserver((mutations) => {
        if (platformdocument.querySelector(querySelectorTxt)) {
          observer.disconnect();
          resolve(platformdocument.querySelector(querySelectorTxt));
        }
      });
      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(platformdocument.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  async fixRectSize() {
    // first we wait untl nightingale navigation is rendered
    const myElement = await this.awaitElementIsRendered(
      'nightingale-navigation'
    );

    // we then add height 19 to it
    (myElement as HTMLElement).addEventListener('mousedown', (ev) => {
      const platformdocument = this.platform.getDocument();
      (
        platformdocument.querySelector(
          'nightingale-navigation > svg > g.brush > rect.selection'
        ) as SVGRectElement
      ).setAttribute('height', '19');
    });
  }

  // Added for hiding Nightingale sequence axis
  async hideSequenceAxis() {
    // first we wait untl nightingale axis is rendered
    const myElement = await this.awaitElementIsRendered(
      'nightingale-sequence > svg > g.x.axis'
    );
    // we then add display none to it
    (myElement as SVGGElement).setAttribute('display', 'none');
  }

  public toggleAddTrackDialog(event?: any) {
    if (event === null) return;
    this.isAddDialogOpen = true;
  }

  /**
   * Just add the logic to open edit dialog here
   */
  public toggleEditTrackDialog(event?: any) {
    if (event === null) return;
    const prevIsOpen = this.isEditDialogOpen;
    this.isEditDialogOpen = !prevIsOpen;
  }

  public toggleZoomDialog(event?: any) {
    if (event === null) return;
    const prevIsOpen = this.isZoomDialogOpen;
    this.isZoomDialogOpen = !prevIsOpen;
  }

  public closeAddTrackDialog(){
    this.isAddDialogOpen = false;
  }

  public closeZoomDialog(){
    this.isZoomDialogOpen = false;
  }

  public closeEditTrackDialog(){
    this.isEditDialogOpen = false;
  }

  public async zoomAndHighlightTrack(event){
    // first we wait untl nightingale navigation is rendered
    const nightingaleNavigation = await this.awaitElementIsRendered(
      'nightingale-navigation'
    ) as Element;
    // we then just dispatch events to each and let them bubble
    if(event.type === "highlight"){
      const eventObj = new CustomEvent('change', {
        detail: {
          'highlight': `${event.start}:${event.end}`,
        },
        bubbles: true,
        cancelable: true,
      });
      nightingaleNavigation.dispatchEvent(eventObj);
    }
    if(event.type === "zoom"){
      const eventObj = new CustomEvent('change', {
        detail: {
          'display-start': event.start,
          'display-end': event.end
        },
        bubbles: true,
        cancelable: true,
      });
      nightingaleNavigation.dispatchEvent(eventObj);
    }
    this.gaService.eventEmitter('highlight_custom_track', 'custom_annotations', 'click', 'track_highlight', 'User tried to highlight track');
 
    this.isZoomDialogOpen = false;
  }

  public triggerIn3DColouring(event) {
    if (!event) return;
    const eventId = event.trackId;
    if (eventId.includes('plddt')) {
      this.updateStructureColor({scheme:'plddt'});
      this.gaService.eventEmitter('in_3D', 'custom_annotations', 'click', 'pLDDT', 'Clicks “in 3D” chip next to pLDDT track');
    }
    else if (eventId.includes('missense')) {
      this.updateStructureColor({scheme:'missense'});
      this.gaService.eventEmitter('in_3D', 'custom_annotations', 'click', 'alphamissense', 'Clicks “in 3D” chip next to AlphaMissense Pathogenicity Heatmap');
    }
    else if (eventId.includes('custom')) {
      const customTrackId = eventId.split('->')[0];
      // const customTrackData = this.customTracks[parseInt(customTrackIdx)];
      const customTrackData = this.customTracks.find((trck) => trck.id === customTrackId);
      if (!customTrackData) {
        console.warn("custom track not found in data");
        return;
      }
      const eventData = {
        scheme: 'custom',
        trackData: {
            trackId: customTrackData.trackId,
            trackName: customTrackData.trackName,
            segments: customTrackData.data[0].locations[0].fragments.map((frag) => { return {start: frag.start, end: frag.end}}),
            color: customTrackData.data[0].color
        }
      }
      this.updateStructureColor(eventData);
      this.gaService.eventEmitter('in_3D', 'custom_annotations', 'click', 'custom_track', 'Clicks “in 3D” chip next to added custom tracks');
    }
  }

  handleSelection(value: string) {
    const urlMap = {
      heatmapdata: {
        url: this.csvAMFileUrl,
        tag: 'AM_heatmap_download',
        msg: 'Clicks on downloading AM heatmap csv',
      },
      hg19: {
        url: this.amAnnotationsHg19Url,
        tag: 'AM_hg19_download',
        msg: 'Clicks on downloading AM hg19 csv',
      },
      hg38: {
        url: this.amAnnotationsHg38Url,
        tag: 'AM_hg38_download',
        msg: 'Clicks on downloading AM hg38 csv',
      },
    };

    const downloadUrl = urlMap[value].url;
    if (downloadUrl) {
      this.downloadCSVFile(downloadUrl);
    } else {
      alert(`Don't have ${value} csv file url from API`);
    }

    this.gaService.eventEmitter(
      urlMap[value].tag,
      'AlphaMissense',
      'click',
      urlMap[value].tag,
      urlMap[value].msg
    );
    // Do something with the selected value
  }

  downloadCSVFile(csvurl) {
    const platformdocument = this.platform.getDocument();
    const link = platformdocument.createElement('a');
    link.href = csvurl;
    platformdocument.body.appendChild(link);
    link.click();
    this.platform.getDocument().body.removeChild(link);
    const windowWithURL = this.platform.getWindow() as Window & {
      URL: typeof URL;
    };

    windowWithURL.URL.revokeObjectURL(csvurl);
  }

  resetFilters() {
    this.isReset = false;

    this.isPathogenic = false;
    this.isBenign = false;
    this.isUncertain = false;

    this.isPathogenicDisabled = true;
    this.isBenignDisabled = true;
    this.isUncertainDisabled = true;

    this.silder1Min = 0;
    this.silder1Max = 0.34;

    this.silder2Min = 0.34;
    this.silder2Max = 0.56;

    this.silder3Min = 0.56;
    this.silder3Max = 1;

    this.heatmapOne.setFilter(
      (d, x, y, xIndex, yIndex) => d.category === 'wt' || d.score > 0
    );

    this.gaService.eventEmitter(
      'AM_reset_filter',
      'AlphaMissense',
      'click',
      'AM_reset_filter',
      'Clicks on the resetting filters'
    );
  }

  resetZoom() {
    this.heatmapOne.zoom(undefined);
  }
  clearMolstarSelection() {
    this.clearRegion.emit();
  }

  handleFilters(type?: string, name?: string) {
    this.isReset = true;

    const filterData = [
      { min: this.silder1Min, max: this.silder1Max },
      { min: this.silder2Min, max: this.silder2Max },
      { min: this.silder3Min, max: this.silder3Max },
    ];

    if (!this.isBenign) {
      this.silder1Min = 0;
      this.silder1Max = 0.34;
      filterData[0] = { min: -2, max: -2 };
    }

    if (!this.isUncertain) {
      this.silder2Min = 0.34;
      this.silder2Max = 0.56;
      filterData[1] = { min: -2, max: -2 };
    }

    if (!this.isPathogenic) {
      this.silder3Min = 0.56;
      this.silder3Max = 1;
      filterData[2] = { min: -2, max: -2 };
    }

    if (!this.isBenign && !this.isUncertain && !this.isPathogenic) {
      filterData[0] = { min: 0, max: 0.34 };
      filterData[1] = { min: 0.34, max: 0.56 };
      filterData[2] = { min: 0.56, max: 1 };
      this.isReset = false;
    }
    let eventLable = '';
    let eventName = '';
    let eventDesc = '';

    if (type === 'category') {
      eventName = 'AM_checkbox';
      eventLable =
        name === 'benign'
          ? 'AM_checkbox_benign'
          : name === 'pathogenic'
          ? 'AM_checkbox_pathogenic'
          : 'AM_checkbox_uncertain';
      eventDesc =
        name === 'benign'
          ? 'Clicks on the check box for benign category'
          : name === 'pathogenic'
          ? 'Clicks on the check box for pathogenic category'
          : 'Clicks on the check box for uncertain category';
    }
    if (type === 'range') {
      eventName = 'AM_filter';
      eventLable =
        name === 'benign'
          ? 'AM_drag_benign'
          : name === 'pathogenic'
          ? 'AM_drag_pathogenic'
          : 'AM_drag_uncertain';
      eventDesc =
        name === 'benign'
          ? 'Clicks and dragging on the filter bar benign'
          : name === 'pathogenic'
          ? 'Clicks and dragging on the filter bar pathogenic'
          : 'Clicks and dragging on the filter bar uncertain';
    }
    this.gaService.eventEmitter(
      eventName,
      'AlphaMissense',
      'click',
      eventLable,
      eventDesc
    );

    this.applyFilters(filterData);
  }

  applyFilters(rangeList: { min: number; max: number }[]) {
    const filterFn = (d, x, y, xIndex, yIndex) => {
      // show this data -> score is in min and max && category is available
      if (
        (d.score >= rangeList[0].min && d.score < rangeList[0].max) ||
        (d.score >= rangeList[1].min && d.score < rangeList[1].max) ||
        (d.score >= rangeList[2].min && d.score <= rangeList[2].max) ||
        d.category === 'wt'
      ) {
        return true;
      }
    };
    this.heatmapOne.setFilter(filterFn);
  }

  getVariants(csvData2: string, filterBy, rangeFilter) {
    const variants = [];
    const DELIMITER = ',';
    const MUTATION_COLUMN = 0;
    const SCORE_COLUMN = 1;
    const CLASS_COLUMN = 2;
    const N_HEADER_ROWS = 0;

    const lines = csvData2
      .replace(/\r/g, '')
      .split('\n')
      .filter((line) => line.trim() !== '' && !line.trim().startsWith('#'));
    if (N_HEADER_ROWS > 0) lines.splice(0, N_HEADER_ROWS);
    const rows = lines.map((line) => line.split(DELIMITER));
    rows.shift();

    for (const row of rows) {
      const mutation = row[MUTATION_COLUMN];
      const score = Number(row[SCORE_COLUMN]);
      const colorclass = row[CLASS_COLUMN];
      const match = mutation.match(/([A-Za-z]+)([0-9]+)([A-Za-z]+)/);
      if (!match)
        throw new Error(
          `FormatError: cannot parse "${mutation}" as a mutation (should look like Y123A)`
        );
      const mutationFrom = match[1];
      const seq_id = match[2];
      const mutationTo = match[3];

      if (filterBy.length > 0) {
        if (!filterBy.includes(colorclass)) continue;
      }

      if (rangeFilter != '') {
        if (score < rangeFilter.min || score > rangeFilter.max) {
          continue; // Score is outside the range
        }
      }

      const colorResidue = this.getColorResidue(colorclass);

      const variant = {
        score: score,
        start: Number(seq_id),
        referenceVariant: mutationFrom,
        variant: mutationTo,
        category: colorclass,
        xValue: Number(seq_id),
        yValue: mutationTo,
      };

      variants.push(variant);
    }
    this.changeDetectorRef.detectChanges();
    return variants;
  }

  getColorResidue(colorclass) {
    const colors = {
      LPath: '#ED1E24',
      LBen: '#3853A3',
      Amb: '#A8A9AC',
    };
    return colors[colorclass] || '';
  }

  async getAMDataold(filterBy, rangeFilter) {
    const csvData2 = this.csvAmData;

    if (!csvData2.includes('<!DOCTYPE html>')) {
      const variants = this.getVariants(csvData2, filterBy, rangeFilter);
      for (let i = 0; i < this.heatmapSequence.length; i++) {
        variants.push({
          score: -1,
          start: i + 1,
          referenceVariant: this.heatmapSequence[i],
          variant: this.heatmapSequence[i],
          category: 'wt',
        });
      }

      const variationData = {
        variants: variants,
      };

      this.variantsData = variationData;
      return variationData;
    }
  }

  async getAMData(filterBy, rangeFilter) {
    const csvData2 = this.csvAmData;
    if (csvData2 === undefined) return undefined;

    if (!csvData2.includes('<!DOCTYPE html>')) {

      const variants = this.getVariants(csvData2, filterBy, rangeFilter);

      for (let i = 0; i < this.heatmapSequence.length; i++) {
        variants.push({
          score: -1,
          start: i + 1,
          referenceVariant: this.heatmapSequence[i],
          variant: this.heatmapSequence[i],
          category: 'wt',
          xValue: i + 1,
          yValue: this.heatmapSequence[i],
        });
      }

      const variationData = {
        variants: variants,
      };

      this.variantsData = variationData;
      return variationData;
    } else {
      return undefined;
    }
  }

  async fetchAndProcessVariants() {
    let amData = await this.getAMData(
      this.selectedCategories,
      this.selectedRange
    );
    if (amData === undefined) return undefined;
    this.length = amData.variants.length;

    this.variantsData = amData;
    return this.variantsData.variants;
  }

  async initHeatMap() {
    // let amData = await this.getAMData(
    //   this.selectedCategories,
    //   this.selectedRange
    // );
    // this.length = amData.variants.length;

    // this.variantsData = amData;

    // let maxValue: number = parseFloat(d3.max(this.variantsData.variants, (d: any) => d.start + 1)!);
    // let xDomainAlphaMissense = d3.range(1, maxValue);
    // this.afdbData = [
    //   {
    //     id: 'plddt',
    //     type: 'TrackColouredSequence',
    //     name: 'pLDDT',
    //     data: 'DDDDDDDDDDDDDDDDDDDDLLLLLLDDDDDLDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDLMMMMMMHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHMMMMHHHHHHHHHHHHHHHHHHHHHHHHMHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHMMMMMMMMMMMMHHHHHHHHHHHHHHHHHHHHHHHHMMMMMMHHHHHHHHHHHHHHHHHMMMMMMHHHHHHHHHHHHHHHMHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHMMMMMMMMMMMMMMMMLLLLLLLLLLLLLLLDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDLMMMMMMHHMMMMHHMHHHHHHHHHMMMMMMMMMMMMMMHHHHHHHHHHHHHHHHHHHHHHHHHHHHHMMMMMMLMLLMMMMMHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHMMMLLLDLMMMHHHHHHHMMMMHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHMMMMMMMMMMMMLMMMMHHHHHHHHHHHHHHHHHHHHHMHHHHHHHHHHHHHHHHHHHHHHHMHHHHHHHHHHHHHHHHMMMMMMHMHHHHHHHHHHHHH',
    //     dataScale: 'H:90,M:70,L:50,D:0',
    //     dataRange: '#ff7d45:0,#ffdb13:50,#65cbf3:70,#0053d6:90,#0053d6:100',
    //     status: 'ready-has-data',
    //     isExpandable: false,
    //     trackHeight: 20,
    //     colourIn3DControl: true,
    //   },
    //   {
    //     id: 'alpha-missense',
    //     type: 'TrackHeatmapSequence',
    //     name: 'AlphaMissense Pathogenicity Heatmap',
    //     data: this.variantsData.variants,
    //     heatmapId: 'heatmap-test',
    //     xDomain: xDomainAlphaMissense,
    //     yDomain: ['G', 'A', 'V', 'L', 'I', 'S', 'T', 'C', 'M', 'D', 'N', 'E', 'Q', 'R', 'K', 'H', 'F', 'Y', 'W', 'P'],
    //     checkpoints: [0, 0.1132, 0.2264, 0.3395, 0.4527, 0.5895, 0.7264, 0.8632, 1],
    //     colours: ['#2166ac', '#4290bf', '#8cbcd4', '#c3d6e0', '#e2e2e2', '#edcdba', '#e99e7c', '#d15e4b', '#b2182b'],
    //     heatmapType: 'AFdbAlphaMissense',
    //     status: 'ready-has-data',
    //     isExpandable: false,
    //     trackHeight: 295,
    //     colourIn3DControl: true,
    //     hasXScale: true,
    //     xScaleText: 'Residue sequence number',
    //     hasYScale: true,
    //     yScaleText: 'Alternative amino acids',
    //     mirrorYScale: true,
    //     tooltipContentFn: (d: any, x: number, y: number) => {
    //       if (!d) return '';
    //       let tooltipContent = `
    //         Score: <b>${d.score.toFixed(3)}</b><br>
    //         Variant: <b>${d.referenceVariant}${x}${y}</b><br>
    //       `;
    //       if (d.category === 'wt') {
    //         tooltipContent = `
    //           Score: <b>N/A</b><br>
    //           Variant: <b>${d.referenceVariant}${x} (reference)</b><br>
    //         `;
    //       }
    //       return tooltipContent;
    //     },
    //   },
    // ];

    // We then await until nightingale-navigation is rendered on page
    const container_heatmap = await this.awaitElementIsRendered(
      '#alpha-missense-heatmap-track'
    ) as any;
    await container_heatmap.updateComplete;
    this.heatmapOne = container_heatmap.heatmapInstance;

    // // We then await until in 3D buttons are rendered on page
    // await this.awaitElementIsRendered(
    //   '.in-3d-btn'
    // );
    // const in3DBtns = document.querySelectorAll('.in-3d-btn');
    // in3DBtns[0].classList.add('active');
  }
}
